import { connect } from 'react-redux'
import React, { Component } from 'react'
import './modals.css'
import { createAction } from 'redux-actions'
import UpgradeModal from './UpgradeModal'
import { EDIT_USER  } from '../../actions'

const mapStateToProps = (state, ownProps) => ({
  me: state.me,
})

class ExceedsLimitsModal extends Component {
  constructor() {
    super()
  }

  render() {
    const { me, dispatch } = this.props

    let maxSizeStr = ''
    if (me.plan_max_size) {
      maxSizeStr = `${me.plan_max_size.toString()}GB`
      if (me.plan_max_size < 1) {
        maxSizeStr = `${(me.plan_max_size * 1000).toString()}MB`
      }
    }
    let maxLengthStr = ''
    if (me.plan_max_length) {
      maxLengthStr = `${(me.plan_max_length / 60).toString()} min`
    }

    return (
      <UpgradeModal
        isOpen={me.videoExceedsLimits}
        onClose={() => dispatch(createAction(EDIT_USER)({ videoExceedsLimits: null }))}
        darkMode={this.props.me.dark_mode}
        noTrial={me.no_trial}
        srcInternal={this.props.srcInternal || `${me.videoExceedsLimits}-error`}
        header={!me.videoExceedsLimits ? '' : 
          me.videoExceedsLimits.includes('toolarge') ? 
          `This video exceeds the max file size for your plan (${maxSizeStr})`
          : me.videoExceedsLimits == 'clipper-toolong' ?
          `This clip exceeds the duration limit for your plan (${maxLengthStr})`
          :
          `This video exceeds the duration limit for your plan (${maxLengthStr})`}
        subheader={!me.videoExceedsLimits ? '' :  `To ${
              me.videoExceedsLimits.includes('clipper') ? 'create' 
            : me.videoExceedsLimits.includes('trim') ? 'trim' 
            : 'upload'
          } ${
            me.videoExceedsLimits.includes('toolarge') ? 'larger files' 
            : 'longer videos'
          }, please upgrade to Streamable Pro.`}

      />
    )
  }
}

export default connect(mapStateToProps)(ExceedsLimitsModal)
